import LandingPagePreview from "pages/ManagementPage/LandingPagePreview/LandingPagePreview";

export default LandingPagePreview;
